import React, { useImperativeHandle, useRef } from 'react';
import AddImageCard, {
  AddImageCardHandle,
} from './images/AddImageCard';

interface PortfolioEmptyStateProps {
  onImagesUploaded: (urls: string[]) => void;
  onUploadStatusChange?: (uploading: boolean) => void;
}

export interface PortfolioEmptyStateHandle {
  openFilePicker: () => void;
}

const PortfolioEmptyState = React.forwardRef<
  PortfolioEmptyStateHandle,
  PortfolioEmptyStateProps
>(({ onImagesUploaded, onUploadStatusChange }, ref) => {
  const addImageCardRef = useRef<AddImageCardHandle>(null);

  useImperativeHandle(ref, () => ({
    openFilePicker: () => {
      if (addImageCardRef.current) {
        addImageCardRef.current.openFilePicker();
      }
    },
  }));

  return (
    <div className="text-center py-6 px-4 border border-dashed rounded-xl flex flex-col items-center justify-center gap-4">
      <div className="bg-muted rounded-full p-3">
        <img
          src="/lovable-uploads/9e8df335-b81d-4efd-99b8-3e682345adcd.png"
          alt="No projects"
          className="h-12 w-12"
        />
      </div>
      <h3 className="text-lg font-semibold mt-2">No Portfolio Projects Yet</h3>
      <p className="text-muted-foreground text-sm max-w-md mx-auto">
        Upload up to 20 images (JPEG, PNG, GIF, or WEBP), max 5MB each. Aim for
        1600×1600px+.
      </p>
      <AddImageCard
        ref={addImageCardRef}
        onImageUrlChange={onImagesUploaded}
        onCancel={() => {}}
        onUploadStatusChange={onUploadStatusChange}
        className="w-full max-w-sm mt-2"
      />
    </div>
  );
});

export default PortfolioEmptyState; 